import React from 'react';
import { StyledAddCoBuyerButton } from './customer.style';
import type { AddCoBuyerButtonProps } from '../../types/ConsumerProps';

const AddCoBuyer: React.FC<AddCoBuyerButtonProps> = ({ onAddCoBuyer, icon: Icon }) => (
    <StyledAddCoBuyerButton
        forwardedAs="button"
        size="xsmall"
        weight="semibold"
        data-testid="showroom-header-add-cobuyer"
        onClick={onAddCoBuyer}
    >
        Add Co-Buyer
        {Icon && <Icon />}
    </StyledAddCoBuyerButton>
);

export default AddCoBuyer;
